var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14C0.5 6.51781 6.51781 0.5 14 0.5C21.4822 0.5 27.5 6.51781 27.5 14C27.5 21.4822 21.4822 27.5 14 27.5C6.51781 27.5 0.5 21.4822 0.5 14Z",
    stroke: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6917 14.2333C22.75 14.1167 22.75 13.9417 22.6917 13.7667C22.6333 13.7083 22.6333 13.65 22.575 13.5917L17.9083 8.925C17.675 8.69167 17.325 8.69167 17.0917 8.925C16.8583 9.15833 16.8583 9.50833 17.0917 9.74167L20.7667 13.4167H5.83333C5.48333 13.4167 5.25 13.65 5.25 14C5.25 14.35 5.48333 14.5833 5.83333 14.5833H20.7667L17.0917 18.2583C16.8583 18.4917 16.8583 18.8417 17.0917 19.075C17.2083 19.1917 17.3833 19.25 17.5 19.25C17.6167 19.25 17.7917 19.1917 17.9083 19.075L22.575 14.4083C22.6333 14.35 22.6917 14.2917 22.6917 14.2333Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0e599dab4086f27b3c29be4deb5d6185.svg";
export { ForwardRef as ReactComponent };